import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import VueBreadcrumbs from 'vue-2-breadcrumbs';

const tokenPrefix = process.env.VUE_APP_TOKEN_PREFIX;

Vue.use(VueRouter);
Vue.use(VueBreadcrumbs);

const Router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

const home = { name: 'home' };

Router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage[`${tokenPrefix}token`];

  if (isAuthenticated) {
    if (to.meta.requiresAuth) {
      if (!localStorage.acc && !localStorage[`${tokenPrefix}token`]) {
        next(home);
      } else if (to.meta.adminAuth || to.meta.recruiterAuth) {
        if (
          localStorage.acc === 'admin' ||
          localStorage.acc === 'recruiter' ||
          localStorage.acc === 'user' ||
          localStorage.acc === 'marketing'
        ) {
          next();
        } else {
          next(home);
        }
      } else if (to.meta.managerAuth || to.meta.userAuth) {
        if (localStorage.acc === 'manager' || localStorage.acc === 'user') {
          // console.log('manager/user');
          next();
        } else {
          next(home);
        }
      } else if (to.meta.candidateAuth) {
        if (localStorage.acc === 'candidate') {
          // console.log('candidate');
          next();
        } else {
          next(home);
        }
      } else {
        next();
      }
    } else {
      next();
    }
  } else if (to.meta.requiresAuth) {
    next(home);
  } else {
    next();
  }
});

export default Router;
